import { Injectable } from '@angular/core';
import jwt_decode from "jwt-decode";
import { Observable, of, tap } from 'rxjs';
import { IAuthToken } from '../interfaces/auth-token';

const AUTH_TOKEN = 'auth-token';
const USER_PRIVILEGES = 'user-privs';

@Injectable({
  providedIn: 'root'
})

export class TokenStorageService {

  constructor() { }

  // Save the auth token in the local storage
  public setAuthToken (authToken: string): void {
    localStorage.removeItem(AUTH_TOKEN);
    localStorage.setItem(AUTH_TOKEN, authToken);
  }

  // Retrieve the auth token from the local storage
  public getAuthToken(): string | null {
    return localStorage.getItem(AUTH_TOKEN);
  }  

  // Save the user privileges in the local storage
  public setUserPrivileges (userPrivileges: string[]): void {
    localStorage.removeItem(USER_PRIVILEGES);
    localStorage.setItem(USER_PRIVILEGES, userPrivileges.join('|'));
  }

  // Retrieve the user privileges from the local storage
  public getUserPrivileges(): string[] | null {
    return (localStorage.getItem(USER_PRIVILEGES)  || '').split('|');
  }  

  // Verify whether the current user is authorized against different claims
  public isUserAuthorized(requiredPrivileges: string[]): Observable<boolean> {
    let isUserAuthorized: boolean = false;
    // if (!this.isTokenExpired()) {
      if (this.arePrivilegesGranted(requiredPrivileges)) {
        isUserAuthorized = true;
      }
    // }
    return of(isUserAuthorized).pipe(tap((v) => console.log(v)));
  }

  // Verify whether the auth token has not expired yet
  private isTokenExpired(): boolean {
    let isTokenExpired: boolean = true;
    let tokenString: string = this.getAuthToken() || '';
    if (tokenString) {
      let authToken : IAuthToken = jwt_decode(tokenString);
      isTokenExpired = authToken.exp * 1000 > Date.now();
    }
    return isTokenExpired;
  }

  // Verify that the auth token has required privileges
  private arePrivilegesGranted(requiredPrivileges: string[]): boolean {
    requiredPrivileges.forEach(reqPriv => {
      // const decoded: string = Buffer.from(reqPriv, 'base64').toString('utf8');
    })
    return true;
  }

}

